var Backbone = require('backbone');
var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');

require('owl.carousel');
require('owl.carousel/dist/assets/owl.carousel.css');

require('./Objects.less');

module.exports = Base.extend({
    template: require('./Objects.jinja'),

    el: '.Objects',

    events: {
        'click .Objects-more': 'showMore'
    },

    initialize: function (options) {
        Base.prototype.initialize.call(this, options);

        this.objects = this.options.objects || [];

        if (app.settings.isMobile && this.options.short) {
            this.$('.Objects-items').owlCarousel({
                items: 1,
                autoWidth: true,
                loop: true
            });
        }
    },

    showMore: function () {
        this.$el.addClass('Objects--isAllVisible');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Objects/Objects.js
// module id = 19
// module chunks = 0